import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  ApiBuilder,
  AppConfigService,
  HttpHeadersPayload,
  HttpRequestMethods,
  ReplaceItem,
  handleError
} from '@com-delta-idp/mnx-utils';
import { Observable } from 'rxjs';
import { EndpointKey, IDP_APP, MFA_OAUTH_URL } from '../../../constants';
import {
  OauthAEMConfig,
  SubmitNewPassword,
  SubmitNewPasswordPayload
} from '../../../models';
import { UtilService } from '../../util-service/util-service';

@Injectable({
  providedIn: 'root'
})
export class SubmitNewPasswordService {
  submitNewPasswordHeader: HttpHeadersPayload = {
    'Content-Type': 'application/vnd.pingidentity.checkPasswordReset+json',
    'X-XSRF-Header': 'PingFederate',
    rejectUnauthorized: 'false'
  };

  _errorHandler = handleError.bind(this);

  constructor(
    private http: HttpClient,
    private appConfig: AppConfigService,
    private utils: UtilService
  ) {}

  submitNewPassword = (
    authConfig: OauthAEMConfig,
    flowIdValue: string,
    newPassword: string
  ): Observable<SubmitNewPassword> => {
    const getSubmitNewPasswordUrl = this.utils.getPingServiceUrl(
      authConfig,
      flowIdValue
    ).loginAuthWithCredentialsUrl;

    const submitNewPasswordUrl: ReplaceItem[] = [
      {
        src: MFA_OAUTH_URL,
        target: getSubmitNewPasswordUrl
      }
    ];

    const payload: SubmitNewPasswordPayload = {
      newPassword: newPassword
    };

    return new ApiBuilder<SubmitNewPasswordPayload, SubmitNewPassword>(
      this.http,
      this.appConfig
    )
      .app(IDP_APP.COMMON)
      .endpointKey(EndpointKey.MFA_OAUTH_URL)
      .overrideEndpoint(submitNewPasswordUrl)
      .method(HttpRequestMethods['POST'])
      .timeOut(authConfig.MFA_TIMEOUT ?? 10000)
      .payload(payload)
      .httpHeaders(this.submitNewPasswordHeader)
      .errorHandler(this._errorHandler)
      .library('SUBMIT_NEW_PASSWORD_SERVICE')
      .withCredentials(true)
      .create();
  };
}
